import type { VoidComponent } from "solid-js";
import { For } from "solid-js";
import DraggableList from "../../pages/customer/dnd/DraggableList";
import DraggableListItem from "../../pages/customer/dnd/DraggableListItem";
import type { IconName } from "../../components/icon/Icon";
import { isNil } from "lodash-es";
import { useTranslation } from "../../state/i18n";
import EmptyState from "../../components/emptyState/EmptyState";
import type { Stringifiable } from "../../types";

export type Item = {
  id: Stringifiable;
  label: string;
  icon: IconName;
  iconClasses: string;
  selected: boolean;
  onSelected: (value: boolean) => void;
};

type FieldListProps = {
  items: Item[];
  onDragStart?: () => void;
  onOrderUpdate: (fromIndex: number, toIndex: number) => void;
  class?: string;
};

const FieldList: VoidComponent<FieldListProps> = (props) => {
  const { t } = useTranslation();

  let scrollContainerRef!: HTMLDivElement;

  return (
    <div class={`shrink overflow-y-auto py-px ${!isNil(props.class) ? props.class : ""}`} ref={scrollContainerRef}>
      <DraggableList
        scrollContainer={scrollContainerRef}
        monitorDraggableType="COLUMN"
        onDragStart={() => props.onDragStart?.()}
        onDrop={(sourceData, index) => {
          props.onOrderUpdate(sourceData.index, index);
        }}
        items={props.items.map(({ id }) => ({
          id: id.toString(),
        }))}
      >
        <ul>
          <For
            each={props.items}
            fallback={
              <EmptyState
                title={t(($) => $.EXPORT_SUBMISSIONS_EMPTY_COLUMNS_TITLE)}
                description={t(($) => $.EXPORT_SUBMISSIONS_EMPTY_COLUMNS_DESCRIPTION)}
              />
            }
          >
            {(item, index) => (
              <li>
                <DraggableListItem
                  {...item}
                  id={item.id.toString()}
                  index={index()}
                  isLast={index() === props.items.length - 1}
                />
              </li>
            )}
          </For>
        </ul>
      </DraggableList>
    </div>
  );
};

export default FieldList;
